import { Col, Input, SegmentControl, Spinner2 } from 'components';
import { useInfiniteScroll } from 'core';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { UserItem } from './';

let timer;
const SearchUsers = ({ selected, setSelected, handleSelect, primary, setPrimary }) => {
  const [data, setData] = useState([]),
    { t } = useTranslation(),
    [listEndReached, setListEndReached] = useState(false),
    [fetching, setFetching] = useState(false),
    [searchText, setSearchText] = useState(''),
    [selectedType, setSelectedType] = useState(0),
    { removedSuggestions } = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    dispatch = useDispatch();

  useInfiniteScroll('userList', () => fetchData());

  useEffect(() => {
    clearTimeout(timer);
    setData([]);
    setFetching(true);

    timer = setTimeout(() => fetchData(true), 500);
  }, [selectedType, searchText]);

  async function fetchData(searchNew) {
    if (fetching && !searchNew) return;
    setListEndReached(false);

    const res = await Api.post('/users/search', {
      sortBy: 'name',
      text: searchText,
      type: selectedType ? 'team' : 'athlete',
      skip: (!searchNew && data?.length) || 0,
      exclude: removedSuggestions
    });
    setFetching(false);
    if (!res) return;

    if (!res?.length) {
      return searchNew ? setData([]) : setListEndReached(true);
    }

    setData(searchNew ? res : [...data, ...res]);
  }

  function handleExclude(opt, bundle) {
    const item = selected.find((x) => x.user._id === bundle && x.type === 'bundle');
    if (!item) return;

    if (item.excludeIds?.find((x) => x === opt)) {
      return setSelected(
        selected.map((x) => {
          if (x.user._id !== bundle) return x;

          return {
            ...x,
            excludeIds: x.excludeIds.filter((x) => x !== opt)
          };
        })
      );
    }

    setSelected(
      selected.map((x) => {
        if (x.user._id !== bundle) return x;

        return {
          ...x,
          excludeIds: [...(x.excludeIds || []), opt]
        };
      })
    );
  }

  function removeSuggestion(opt) {
    if (selected.find((x) => x.user._id === opt._id)) {
      handleSelect(opt, 'single');
    }

    setData(data.filter((x) => x !== opt));

    dispatch({
      type: 'REMOVE_SUGGESTION',
      payload: opt._id
    });

    Api.post('/users/removeSuggestion', { userId: opt._id });
  }

  return (
    <Col
      ht={!isMobile ? 'calc(100% - 68px)' : 'calc(100% - 138px)'}
      minHt={!isMobile && 'calc(100% - 68px)'}
      wid={isMobile ? 'calc(100% - 16px)' : '100%'}
      bg="#fff"
      marg="22px 0 0"
      centerAll
      start
      pad={isMobile ? '40px 8px 0' : '40px 240px 0'}
    >
      <Input
        wid={isMobile ? 'calc(100% - 8px)' : '358px'}
        search
        placeholder={t('common.search')}
        value={searchText}
        onChange={({ target }) => setSearchText(target.value)}
      />

      {primary && (
        <Col marg="16px 0 0" noFlex wid="100%">
          <UserItem
            user={primary}
            handleSelect={handleSelect}
            handleRemove={(user) => {
              removeSuggestion(user);
              setPrimary(null);
            }}
            handleExclude={handleExclude}
            detailsSelected={selected.find(
              (x) => x.user?._id === primary._id && x.type === 'bundle'
            )}
            pricing={selected.find((x) => x.user?._id === primary._id && x.type === 'single')}
            isPreselected
          />
        </Col>
      )}

      <SegmentControl
        wid={isMobile ? 'calc(100% - 8px)' : '358px'}
        marg="24px 0 0"
        options={[t('common.athletes'), t('common.teams')]}
        selectedIdx={selectedType}
        handleSelect={setSelectedType}
        textStyle={{
          b2: true
        }}
        small
      />

      <Col scrollY wid="100%" marg="20px 0 0" pad="20px 0 0" id="userList" gap="12px" start>
        {fetching && (
          <Col center start noFlex>
            <Spinner2 />
          </Col>
        )}

        {data.map((item, i) => (
          <UserItem
            key={item._id}
            user={item}
            handleSelect={handleSelect}
            handleRemove={removeSuggestion}
            handleExclude={handleExclude}
            detailsSelected={selected.find((x) => x.user?._id === item._id && x.type === 'bundle')}
            pricing={selected.find((x) => x.user?._id === item._id && x.type === 'single')}
          />
        ))}
      </Col>
    </Col>
  );
};

export default SearchUsers;
